var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.6 0.800049H2.5C1.1 0.800049 0 2.00005 0 3.30005V12.7C0 14.1 1.1 15.2 2.5 15.2H17.6C19 15.2 20.1 14.1 20.1 12.7V3.30005C20.1 2.00005 19 0.800049 17.6 0.800049ZM17.4 5.10005L10.5 10.8C10.4 10.9 10.2 10.9 10.1 10.9C10 10.9 9.8 10.9 9.7 10.8L2.8 5.10005C2.5 4.90005 2.5 4.50005 2.7 4.20005C2.9 3.90005 3.3 3.90005 3.6 4.10005L10.1 9.40005L16.6 4.10005C16.9 3.90005 17.3 3.90005 17.5 4.20005C17.7 4.50005 17.6 4.90005 17.4 5.10005Z"}));
}

Email.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 21 16"};

module.exports = Email;

Email.default = Email;
